<template>
    <div class="container admin-submenu-page admin-formatos-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{ labels.title }}</h2>
        </div>
        <div class="admin-table-block mt-4" v-if="listCompany?.length">
            <CorporateDataTable
                :items="listCompany"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
            >
                <template #cell(accionEdit)="data">
                    <b-button
                        style="background-color: #FF924C; width: 30px; height: 30px;"
                        class="md-fab md-primary table-action-btn"
                        @click="editarFormato(data.item)"
                    >
                        <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="admin-table-block mt-4" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        
        <b-modal 
            v-model="showDialogEdit"
            :title="labels.modalTitle"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.company }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.nombre"
                            type="text"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.acronym }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.acronym"
                            type="text"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.formato }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.formato"
                            type="text"
                            class="form-input"
                            placeholder="Nombre del formato"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.formato_interco }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formEdit.formato_interco"
                            type="text"
                            class="form-input"
                            placeholder="Nombre del formato intercompañías"
                        />
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="cerrarModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="grabeFormato" :disabled="isLoading">{{ labels.save }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Company from "../../services/Company"
import CorporateDataTable from "../utils/CorporateDataTable.vue"

export default {
    name: "CargueFormato",
    components: {
        CorporateDataTable
    },
    data: () => ({
        listCompany: [],
        isLoading: false,
        showDialogEdit: false,
        formEdit: {
            id: null,
            nombre: '',
            acronym: '',
            formato: '',
            formato_interco: ''
        }
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Formatos de Cargue",
                    company: "Compañía",
                    acronym: "Acrónimo",
                    formato: "Formato Balance",
                    formato_interco: "Formato Intercompañías",
                    editar: "Editar",
                    noRow: "No hay registros",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterName: "Filtrar compañía...",
                    filterAcronym: "Filtrar acrónimo...",
                    save: "Guardar",
                    close: "Cerrar",
                    modalTitle: "Editar Formatos",
                    infoTitle: "Datos de la compañía",
                    infoText: "Actualiza los formatos de carga para la compañía seleccionada."
                }
            }
            return {
                title: "Upload Formats",
                company: "Company",
                acronym: "Acronym",
                formato: "Balance Format",
                formato_interco: "Intercompany Format",
                editar: "Edit",
                noRow: "There are not records",
                noMatches: "No results found",
                searchPlaceholder: "Search in table...",
                rowsPerPage: "Rows per page:",
                noSort: "No sorting",
                sortAsc: "A-Z / Low to high",
                sortDesc: "Z-A / High to low",
                columns: "Columns",
                showAllColumns: "Show all",
                filters: "Filters",
                clearFilters: "Clear filters",
                filterName: "Filter company...",
                filterAcronym: "Filter acronym...",
                save: "Save",
                close: "Close",
                modalTitle: "Edit Formats",
                infoTitle: "Company information",
                infoText: "Update the upload formats for the selected company."
            }
        },
        allFields() {
            return [
                { key: 'nombre', label: this.labels.company, sortable: true },
                { key: 'acronym', label: this.labels.acronym, sortable: true },
                { key: 'formato', label: this.labels.formato, sortable: true },
                { key: 'formato_interco', label: this.labels.formato_interco, sortable: true },
                { key: 'accionEdit', label: this.labels.editar, thClass: 'text-center', tdClass: 'text-center', sortable: false }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'nombre', type: 'text', placeholder: this.labels.filterName },
                { key: 'acronym', type: 'text', placeholder: this.labels.filterAcronym }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noRow,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        cerrarModal() {
            this.showDialogEdit = false
            this.formEdit = {
                id: null,
                nombre: '',
                acronym: '',
                formato: '',
                formato_interco: ''
            }
        },
        editarFormato(item) {
            this.formEdit = { ...item }
            this.showDialogEdit = true
        },
        grabeFormato() {
            if (this.formEdit.formato == "" && this.formEdit.formato_interco == "") {
                this.$toast.error("Diligenciar al menos un formato")
                return
            }
            
            this.isLoading = true
            this.formEdit.userId = this.$store.state.userId
            
            Company.grabeFormato(this.formEdit)
                .then(() => {
                    this.$toast.success("Información guardada correctamente")
                    
                    this.listCompany = this.listCompany.map((company) => {
                        if (company.id === this.formEdit.id) {
                            return {
                                ...company,
                                formato: this.formEdit.formato,
                                formato_interco: this.formEdit.formato_interco
                            }
                        }
                        return company
                    })
                    
                    this.showDialogEdit = false
                    this.formEdit = {
                        id: null,
                        nombre: '',
                        acronym: '',
                        formato: '',
                        formato_interco: ''
                    }
                })
                .catch((error) => {
                    console.error('Error al guardar:', error)
                    this.$toast.error("Error al guardar la información")
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        cargarFormatos() {
            this.isLoading = true
            Company.getAllFormatos()
                .then((result) => {
                    this.listCompany = result.data.formatos || []
                })
                .catch((err) => {
                    console.error('Error al cargar formatos:', err)
                    this.$toast.error("Error al cargar los formatos")
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    },
    mounted() {
        this.cargarFormatos()
    }
}
</script>

<style src="../main.css"></style>